import { QuotaHelper } from '../../../shared/domain/quota-helper';
import { Quotas, Criteria } from '../../../shared/interfaces/survey.interface';

export type QuotaOption = {
  id: string;
  category: string;
  name: Criteria[];
};

export class SelectedQuotaOption {
  constructor(
    private readonly _quotas: Quotas[],
    private readonly _selectedQuotaIds: string[] = []
  ) {}

  public ids(): QuotaOption[] {
    return this._selectedQuotaIds.reduce((quotaOptions, selectedQuotaId) => {
      const quotaIndex = this._quotas.findIndex(
        (quota) => selectedQuotaId === quota.buyer_quota_id
      );
      if (quotaIndex === -1) {
        return quotaOptions;
      }
      const selectedQuota = this._quotas[quotaIndex];
      const quotaName: string = new QuotaHelper().getNestedQuotaGroup(
        selectedQuota.criteria
      );
      const newQuotaOption = {
        id: selectedQuotaId,
        name: selectedQuota.criteria,
        category: quotaName,
      };
      return [...quotaOptions, newQuotaOption];
    }, <QuotaOption[]>[]);
  }
}
